import { __assign, __rest } from "tslib";
/* tslint:disable */
/* eslint:disable */
/**
 * @typedef {string} Url
 */
/**
 * @typedef {string} GUID
 */
/**
 * @typedef {number} DateTime
 */
var dummy;
var defaultConfig = { endpoint: 'settings' };
var init = function (webOrMobileLogger) { return function (userConfig) {
    if (userConfig === void 0) { userConfig = {}; }
    var defaults = userConfig.defaults, restOfConfig = __rest(userConfig, ["defaults"]);
    var config = __assign(__assign({}, defaultConfig), restOfConfig);
    var factoryInstance = typeof webOrMobileLogger.factory === 'function' ? webOrMobileLogger.factory(config) : webOrMobileLogger;
    var logger = getLogger(factoryInstance);
    return defaults ? logger.util.updateDefaults(defaults) : logger;
}; };
export var initCustomLogger = function (factoryInstance) { return getLogger(factoryInstance); };
var getLogger = function (biLoggerClientFactoryInstance) {
    return new Logger(biLoggerClientFactoryInstance);
};
var Logger = /** @class */ (function () {
    function Logger(biLoggerClientFactoryInstance) {
        var _this = this;
        this.biLoggerClientFactoryInstance = biLoggerClientFactoryInstance;
        this.util = {
            updateDefaults: function (defaults) {
                _this.biLoggerClientFactoryInstance.updateDefaults(defaults);
                return _this;
            },
            log: function (logParams, context) {
                return _this.bi.log(logParams, context);
            }
        };
        biLoggerClientFactoryInstance
            .updateDefaults({ src: 127 });
        this.bi = biLoggerClientFactoryInstance.logger({ endpoint: 'settings' });
    }
    ;
    /**
    * @typedef {Object} settingsChangedParams
    * @property {string} appName - Application Name
    * @property {string} category - Settings panel tab
    * @property {string} componentId - ID of the component in Dev Center
    * @property {string} componentName - Name of the component in Dev Center
    * @property {boolean} isMobile - Event sent from a mobile form factor
    * @property {string} origin - editor/editor_x/ADI
    * @property {string} parameter - Name of the field
    * @property {string} value - Updated value
    **/
    /**
     * Name: Settings Changed. Evid: 200.
     * Event description: Component configuration was changed via Settings panel.
    
     * appName - Type: string. Desc: Application Name
     *
     * category - Type: string. Desc: Settings panel tab
     *
     * componentId - Type: string. Desc: ID of the component in Dev Center
     *
     * componentName - Type: string. Desc: Name of the component in Dev Center
     *
     * isMobile - Type: bool. Desc: Event sent from a mobile form factor
     *
     * origin - Type: string. Desc: editor/editor_x/ADI
     *
     * parameter - Type: string. Desc: Name of the field
     *
     * value - Type: string. Desc: Updated value
     * @param {settingsChangedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.settingsChanged = function (params) {
        return this.bi.log(__assign({ evid: 200 }, params));
    };
    /**
    * @typedef {Object} settingsTabClickedParams
    * @property {string} appName - Application Name
    * @property {string} componentId - ID of the component in Dev Center
    * @property {string} componentName - Name of the component in Dev Center
    * @property {boolean} isMobile - Event sent from a mobile form factor
    * @property {string} origin - editor/editor_x/ADI
    * @property {string} tabName - Name of the clicked tab
    **/
    /**
     * Name: Settings Tab Clicked. Evid: 201.
     * Event description: Settings panel left-side tab was clicked..
    
     * appName - Type: string. Desc: Application Name
     *
     * componentId - Type: string. Desc: ID of the component in Dev Center
     *
     * componentName - Type: string. Desc: Name of the component in Dev Center
     *
     * isMobile - Type: bool. Desc: Event sent from a mobile form factor
     *
     * origin - Type: string. Desc: editor/editor_x/ADI
     *
     * tabName - Type: string. Desc: Name of the clicked tab
     * @param {settingsTabClickedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.settingsTabClicked = function (params) {
        return this.bi.log(__assign({ evid: 201 }, params));
    };
    return Logger;
}());
export { Logger };
export default init;
export function getLoggerConf() {
    return {
        src: 127,
        endpoint: 'settings',
    };
}
//# sourceMappingURL=index.js.map